import {
	type PartnerAvailabilityBulkUpdateDto,
	patchPartnersPartnerIdAvailability,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useMutation } from "@tanstack/react-query";

export function useUpdatePartnerAvailabilityMutation(partnerId: number) {
	return useMutation({
		mutationFn: processResponse((data: PartnerAvailabilityBulkUpdateDto) =>
			patchPartnersPartnerIdAvailability(data, partnerId),
		),
	});
}
